const main = {

  onViewportChanged: function () {
    this.updateAppear();
    lazyImages.updateImages();
  },

  querySelectorCache: {},
  querySelectorCached: function (query) {
    if (!this.querySelectorCache[query]) {
      this.querySelectorCache[query] = document.querySelector(query);
    }

    return this.querySelectorCache[query];
  },

  querySelectorAllCache: {},
  querySelectorAllCached: function (query) {
    if (!this.querySelectorAllCache[query]) {
      this.querySelectorAllCache[query] =
        Array.prototype.slice.call(document.querySelectorAll(query));
    }

    return this.querySelectorAllCache[query];
  },

  elementInView: function (el, bufferZone) {
    bufferZone = bufferZone || 0;
    const rect = el.getBoundingClientRect();

    return (
      rect.bottom + bufferZone >= 0 &&
      rect.top - bufferZone <=
        (window.innerHeight || document.documentElement.clientHeight)
    );
  },

  setVendorStyle: function (element, property, value) {
    element.style['webkit' + property] = value;
    element.style['moz' + property] = value;
    element.style['ms' + property] = value;
    element.style['o' + property] = value;
  },

  appearCache: {},
  updateAppear: function () {
    const appearElements = this.querySelectorAllCached('.appear');
    for (let i = 0; i < appearElements.length; i++) {
      if (this.appearCache[i]) {
        continue;
      }
      const el = appearElements[i];
      if (!this.elementInView(el)) {
        continue;
      }
      this.appearCache[i] = true;
      el.addEventListener('transitionend', (e) => {
        el.classList.remove('appearing');
        el.classList.add('appeared');
      });
      el.classList.add('appearing');
      if (el.classList.contains('appear-notify')) {
        el.dispatchEvent(new Event('appeared'));
      }
    }
  },

  easeInOut: function (currentTime, start, change, duration) {
    currentTime /= duration / 2;
    if (currentTime < 1) {
        return change / 2 * currentTime * currentTime + start;
    }

    currentTime -= 1;
    return -change / 2 * (currentTime * (currentTime - 2) - 1) + start;
  },

  onContactSubmit: function (event) {
    const name = this.querySelectorAllCached('.contact-form input')[0].value;
    const company = this.querySelectorAllCached('.contact-form input')[1].value;
    const phone = this.querySelectorAllCached('.contact-form input')[2].value;
    const email = this.querySelectorAllCached('.contact-form input')[3].value;
    const message = this.querySelectorAllCached('.contact-form textarea')[0].value; //eslint-disable-line

    function isValidEmail (emailAddress) {
      let pattern = new RegExp(/^(('[\w-\s]+')|([\w-]+(?:\.[\w-]+)*)|('[\w-\s]+')([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i); //eslint-disable-line
      return pattern.test(emailAddress);
    }

    if(name === '') {
      alert('Du måste fylla i ett namn');
      return false;
    }

    if(email === '' || phone === '') {
      alert('Du måste fylla telefonnummer och e-postadress.');
      return false;
    }

    if(message === '') {
      alert('Du måste fylla i ett meddelande.');
      return false;
    }

    if( !isValidEmail(email) ) {
      alert('Du måste fylla i en korrekt e-postadress.');
      return false;
    }

    jQuery('.contact-form').addClass('disabled');
    jQuery('.contact-form input').each(
      function (i, e) {
        $(this).attr('disabled', true);
      }
    );

    jQuery.ajax({
      url: window.ajaxurl,
      data: {
        action: 'kontakt',
        name: name,
        company: company,
        phone: phone,
        email: email,
        message: message,
      },
      type: 'POST',
      dataType: 'JSON',
      success: function (response) {
        $('.popup-message-container').addClass('show');
      },
    });

    return true;
  },

  setupListeners: function () {
    $('.js-close-popup').click(
      function (e) {
        e.preventDefault();
        $('.popup-message-container').removeClass('show');
      }
    );
  },

  init: function () {
    this.setupListeners();
  },
};

function documentReady (cb) {
  if (document.readyState !== 'loading') {
    cb();
  } else {
    document.addEventListener('DOMContentLoaded', cb);
  }
}

documentReady(function () {
  main.init();
});
